// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.club-logo-mark {
  flex-shrink: 0;
  object-fit: cover;
}

.club-logo-mark--sm {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.club-logo-mark--md {
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.club-logo-mark--lg {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #fff);
  box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
}

.club-logo-mark--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background:
    radial-gradient(
      120% 90% at 18% 12%,
      color-mix(in srgb, #fff 34%, transparent),
      transparent 55%
    ),
    linear-gradient(
      145deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 82%, #0b3d66) 0%,
      var(--brand-primary, #0877bc) 48%,
      color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #0ea5e9) 100%
    );
  box-shadow:
    inset 0 1px 0 color-mix(in srgb, #fff 28%, transparent),
    0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 24%, transparent);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, #fff);
}

.club-logo-mark--fallback.club-logo-mark--md {
  border-radius: 14px;
}

.club-logo-mark--fallback.club-logo-mark--sm {
  border-radius: 50%;
}

.club-logo-mark--fallback.club-logo-mark--lg {
  border-width: 0;
  box-shadow:
    inset 0 1px 0 color-mix(in srgb, #fff 30%, transparent),
    0 12px 32px color-mix(in srgb, var(--brand-primary, #0877bc) 30%, transparent);
}

.club-logo-mark__icon {
  display: block;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.18));
}

.club-logo-mark__letter {
  display: block;
  font-family: var(--brand-font, Poppins), system-ui, sans-serif;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  -webkit-user-select: none;
          user-select: none;
}

.club-logo-mark--sm .club-logo-mark__letter {
  font-size: 1.05rem;
}

.club-logo-mark--md .club-logo-mark__letter {
  font-size: 1.25rem;
}

.club-logo-mark--lg .club-logo-mark__letter {
  font-size: 3rem;
}

.club-logo-mark--letter {
  /* Keep the gradient disc — letter sits as a profile monogram */
}
`, "",{"version":3,"sources":["webpack://./src/components/ClubLogoMark.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6EAA6E;EAC7E,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX;;;;;;;;;;;KAWG;EACH;;iFAE+E;EAC/E,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf;;kFAEgF;AAClF;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,8DAA8D;EAC9D,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,0CAA0C;EAC1C,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+DAA+D;AACjE","sourcesContent":[".club-logo-mark {\n  flex-shrink: 0;\n  object-fit: cover;\n}\n\n.club-logo-mark--sm {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.club-logo-mark--md {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n}\n\n.club-logo-mark--lg {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  border: 4px solid color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #fff);\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n}\n\n.club-logo-mark--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background:\n    radial-gradient(\n      120% 90% at 18% 12%,\n      color-mix(in srgb, #fff 34%, transparent),\n      transparent 55%\n    ),\n    linear-gradient(\n      145deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 82%, #0b3d66) 0%,\n      var(--brand-primary, #0877bc) 48%,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 55%, #0ea5e9) 100%\n    );\n  box-shadow:\n    inset 0 1px 0 color-mix(in srgb, #fff 28%, transparent),\n    0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 24%, transparent);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, #fff);\n}\n\n.club-logo-mark--fallback.club-logo-mark--md {\n  border-radius: 14px;\n}\n\n.club-logo-mark--fallback.club-logo-mark--sm {\n  border-radius: 50%;\n}\n\n.club-logo-mark--fallback.club-logo-mark--lg {\n  border-width: 0;\n  box-shadow:\n    inset 0 1px 0 color-mix(in srgb, #fff 30%, transparent),\n    0 12px 32px color-mix(in srgb, var(--brand-primary, #0877bc) 30%, transparent);\n}\n\n.club-logo-mark__icon {\n  display: block;\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.18));\n}\n\n.club-logo-mark__letter {\n  display: block;\n  font-family: var(--brand-font, Poppins), system-ui, sans-serif;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);\n  user-select: none;\n}\n\n.club-logo-mark--sm .club-logo-mark__letter {\n  font-size: 1.05rem;\n}\n\n.club-logo-mark--md .club-logo-mark__letter {\n  font-size: 1.25rem;\n}\n\n.club-logo-mark--lg .club-logo-mark__letter {\n  font-size: 3rem;\n}\n\n.club-logo-mark--letter {\n  /* Keep the gradient disc — letter sits as a profile monogram */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
